export default "__VITE_ASSET__ab98ef37__"